import CorporateFareIcon from '@mui/icons-material/CorporateFare'
import { Box, DialogTitle, useTheme } from '@mui/material'
import { styled } from '@mui/material/styles'
import { GROBxLogo } from 'theme/components'
import { dialogTitleStyles } from '../../styles/utilities'
import { moduleColors } from '../../theme/tokens'

const DialogIcon = styled('img')({
  width: 50,
  height: 50,
  borderRadius: '50%',
})

const boxStyles = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
}

const CreateOrganizationHeader = ({ context, onToggleInfo }: { context: any; onToggleInfo?: any }) => {
  const theme = useTheme()
  return (
    <Box sx={boxStyles}>
      <GROBxLogo />
      <Box sx={boxStyles}>
        <DialogTitle sx={dialogTitleStyles(theme)}>{context}</DialogTitle>
        <CorporateFareIcon
          sx={{
            color: moduleColors.organizations,
          }}
        />
      </Box>
    </Box>
  )
}

export default CreateOrganizationHeader
